<template>
    <div class="multiple-choice" :class="{correct, incorrect, disabled}">
        <div class="question-header flex">
            <div class="question-type">
                Question {{configuration.component_type_index}}
            </div>
        </div>
        <slot />
        <template v-if="assignment">
            <template v-if="attempts">
                <div class="flex flex-align multiple-choice-actions">
                    <div @click="submit" class="text-button" :class="{disabled}">Submit Your Answer</div>
                    <div class="ff"></div>
                    <div class="question-points" v-if="complete">
                        {{points}} / {{question.component_points}} Point{{points === 1 ? '' : 's'}}
                    </div>
                    <div class="question-attempts" v-else>
                        {{question.component_attempts - attempts.length}} Attempt{{(question.component_attempts - attempts.length) === 1 ? '' : 's'}} Remaining
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="flex flex-align flex-center multiple-choice-disabled center">
                    Only students can submit responses.
                </div>
            </template>
        </template>
        <div class="flex flex-align flex-center multiple-choice-disabled center" v-else>
            This question can only be answered by students after it is assigned.
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MultipleChoice',
        methods: {
            submit(){
                this.loading = true;

                this.$http.post(`/products/${this.product.product_id}/assignments/${this.assignment.assignment_id}/components/${this.id}`, {answer_id: this.selected})

                //TODO Move this logic into the actual assignment store service
                .then(response => this.$store.dispatch('assignments/attempt', response.$data))
                .catch(response => this.$toasted.error(response.$error))
                .finally(() => this.loading = false);
            }
        },
        props: {
            id: String,
            configuration: Object
        },
        data(){
            return {
                selected: null,
                loading: false
            };
        },
        computed: {
            product(){
                return this.$store.getters.product;
            },
            assignment(){
                return this.$store.getters.assignment;
            },
            question(){
                return this.$store.getters.question(this.id);
            },
            disabled(){
                return this.loading || this.complete;
            },
            correct(){
                return this.attempt ? this.question.component_points === this.attempt.attempt_raw_points : false;
            },
            incorrect(){
                return this.attempt ? this.question.component_points !== this.attempt.attempt_raw_points : false;
            },
            complete(){
                if(this.assignment){
                    return this.assignment.submission_state !== 'started' || this.question.attempts.length === this.question.component_attempts || this.correct;
                }

                return true;
            },
            attempts(){
                return this.question ? this.question.attempts : undefined;
            },
            attempt(){
                return this.question ? this.question.attempts.slice().pop() : undefined;
            },
            points(){
                if(this.attempt){
                    return Math.max(0, this.attempt.attempt_points);
                }

                return 0;
            }
        },
        created(){
            this.$on('select', option => this.selected = option);

            if(this.attempt){
                //If this question has been answered already, set the selected value to the last selected option.
                return this.selected = this.attempt.attempt_value;
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .multiple-choice
    {
        counter-increment: question;
        background: var(--card-background-color);
        border-radius: 3px;
        border: 1px solid @base;
        margin: 50px;
        transition: border-color ease 0.2s;

        p, ul, ol
        {
            margin: 20px;
        }

        &.incorrect
        {
            border-color: @red;

            .question-type
            {
                background: @red;
            }
        }

        &.correct
        {
            border-color: @green;

            .question-type
            {
                background: @green;
            }
        }

        .question-header
        {
            height: 5px;
        }

        .question-type
        {
            font-size: 11px;
            font-weight: 600;
            color: @f;
            height: 24px;
            line-height: 24px;
            padding: 0 10px;
            background: @base;
            border-radius: 12px;
            transition: background-color ease 0.2s;
            top: -12px;
        }
    }

    .answer-choices
    {
        padding: 20px;
    }

    .multiple-choice-actions
    {
        padding: 15px 20px;
    }

    .multiple-choice-disabled
    {
        padding: 30px;
        font-size: 12px;
    }

    .question-attempts, .question-points
    {
        color: var(--secondary-text-color);
        font-size: 14px;
    }

    .sidebar
    {
        .multiple-choice
        {
            margin: 50px 20px;
        }
    }

    @media only screen and (max-width: 1100px)
    {
        .multiple-choice
        {
            margin: 30px;
        }
    }
</style>
